<spike-base-page [breadcrumbItems]="breadcrumbItems()" [title]="title()" [subTitle]="subTitle()">
    @for (entityType of etiquetteConfigList; track $index) {
        <div class="mb-4 spike-card">
            <div class="flex justify-between">
                <div class="font-semibold text-xl">{{entityType.label}}</div>
                <div>
                 <p-button 
                    (click)="onInsert($event, entityType)"
                    icon="pi pi-plus" 
                    severity="primary" 
                    label="Nuovo">
                </p-button>
                </div>
            </div>
        
        <spike-etiquette-list 
            noLabelName="default"
            [etiquetteList]="entityType.list()" 
            (onSelect)="onSelect(entityType, $event)"
            (clickPropagated)="onClickPropagated($event)">
        </spike-etiquette-list>
        </div>
    }
</spike-base-page>

<p-popover #op>
    @if (popoverReady()) {
    <spike-etiquette-form [etiquette]="selectedEtiquette()!" (onSave)="onSave($event)" (onDelete)="onDelete($event)"></spike-etiquette-form>
    }
</p-popover>
